module.exports = __webpack_public_path__ + "static/media/faq yellow.f1ee4437.svg";